/// <reference path="../../definitions/jquery/index.d.ts" />
/// <reference path="../../definitions/jquery.validation/index.d.ts" />
/// <reference path="../../public/component.ts" />

namespace IREP {
    "use strict";

    //Inherit this object instead of Component to get validation in your form.
    export class ValidationComponentV3 extends Component {

        constructor(options: any) {
            super(options);

            //Prevents entering only spaces in any required fields. 
            $.each($.validator.methods, function (key, value) {
                $.validator.methods[key] = function () {
                    if (arguments.length > 0) {
                        arguments[0] = $.trim(arguments[0]);
                    }

                    return value.apply(this, arguments);
                };
            });
        }

        //Call this in your bindEvents function if you want to have standard keyboard command processing.
        //Right now I have two examples set up. Spacebar - handles toggling a checkbox, and handles a button click.  
        public bindKeypress() {
            document.addEventListener('keypress', (e) => this.processKey(e));
        };

        public processKey(e: KeyboardEvent) {
            if (e.keyCode == 13 || e.keyCode == 32) { //Enter or Space
                if ($(e.target).hasClass('option') || $(e.target).hasClass('button') || $(e.target).hasClass('link')) {
                    $(e.target).click();
                    e.preventDefault();
                }
                if ($(e.target).hasClass('onoffswitch')) {
                    var cbx = $(e.target).children('input[type="checkbox"]');
                    cbx.prop('checked', !cbx.prop('checked')); //Flip it.
                    e.preventDefault();
                }
            }
        };

        public validEmail(email: string) {
            let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return emailRegex.test(email);
        }

        public validPhoneNumberAsmo(phoneNumber: string) {
            let phoneRegext = new RegExp("^(\\+\\d{1,2}\\s)?\\(?\\d{3}\\)?[\\s.-]?\\d{3}[\\s.-]?\\d{4}$");
            return phoneRegext.test(phoneNumber);
        }

        public validPhoneNumberLar(phoneNumber: string) {
            let phoneRegext = new RegExp("^\\+?\\(?\\d{1,3}\\)?(\\s|-)?\\d{1,5}(\\s|-)?\\d{4,9}");
            return phoneRegext.test(phoneNumber);
        }

        public validPhoneNumberBrazil(phoneNumber: string) {
            //(##) ########
            let phoneRegext = new RegExp("\\(([0-9]{2}|0{1}((x|[0-9]){2}[0-9]{2}))\\)\\s*[0-9]{3,4}[- ]*[0-9]{4}");
            return phoneRegext.test(phoneNumber);
        }

        //Forms - the form to configure validation for.
        //setErrors - set the .control-row title attribute with the error text. 
        public bindValidation(forms: JQuery, setErrors: boolean) {
            if (forms.length > 0) {
                if (forms.data("validator") === undefined) {
                    forms.validate(); //Initialize if not already initialized (extras page needs this.)
                }
                let validationSettings = forms.data("validator").settings;
                validationSettings.highlight = (element, errorClass) => $(element).parents(".control-row").addClass("has-error");
                validationSettings.unhighlight = (element, errorClass) => $(element).parents(".control-row").removeClass("has-error");
                validationSettings.errorPlacement = (error, element) => {
                    if (setErrors) {
                        $(element).parents(".control-row").attr("title", error.text());
                    }
                };

                $(".mt-select2").on("select2:close", (e) => $(e.target).valid());
                $.each(forms.find(".control-row .field-validation-error"), (e) => validationSettings.highlight(e));
            };
        }
    }
}